import { render, staticRenderFns } from "./RoleName.vue?vue&type=template&id=0c3dda5e&scoped=true&"
import script from "./RoleName.vue?vue&type=script&lang=js&"
export * from "./RoleName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3dda5e",
  null
  
)

export default component.exports